import React from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import AuthForm from "../components/AuthForm";

export default function Login({ setIsLoggedIn }) {
  const navigate = useNavigate();

  const handleLogin = async (form) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/login`, {
        email: form.email,
        password: form.password,
      });

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        setIsLoggedIn(true);

        // Check if user needs to complete billing setup
        if (res.data.user && res.data.user.needs_billing_setup) {
          navigate("/refer/billing");  // Redirect to billing FIRST
        } else {
          navigate("/refer/dashboard");  // Normal flow for users who completed setup
        }
      } else {
        alert("Login failed: No token returned");
      }
    } catch (err) {
      console.error("Login error:", err);
      if (err.response && err.response.status === 401) {
        alert("Username and/or Password Incorrect, Please Try Again.");
      } else if (err.response && err.response.status === 403) {
        // Email verification required
        alert(err.response.data.msg || "Please verify your email before logging in. Check your inbox for the verification link.");
      } else {
        alert("Login failed due to a network or server error.");
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-backgroundLight">
      <img src="/PlexysLogo012526.png" alt="Plexys Logo" className="w-48 h-auto mb-6" />

      <div className="w-full max-w-md bg-white p-6 rounded shadow-md">
        <AuthForm onSubmit={handleLogin} label="Login" />

        <p className="text-center mt-4 text-sm text-gray-600">
          New to Plexys?{" "}
          <Link
            to="/refer/register"
            className="text-primary font-medium hover:underline"
          >
            Register here
          </Link>
        </p>
      </div>
    </div>
  );
}
